import { render, staticRenderFns } from "./SidebarNickname.vue?vue&type=template&id=37ddc34d&scoped=true&"
import script from "./SidebarNickname.vue?vue&type=script&lang=js&"
export * from "./SidebarNickname.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNickname.vue?vue&type=style&index=0&id=37ddc34d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddc34d",
  null
  
)

export default component.exports